import { HttpClient, HttpParams } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { environment } from 'src/environments/environment';

interface ApiResponse {
  success: boolean;
  data: DataItem[];
}

interface DataItem {
  id: number;
  created_at: string;
  updated_by: string;
}

@Component({
  selector: 'app-rating-activity',
  templateUrl: './rating-activity.component.html',
  styleUrls: ['./rating-activity.component.scss']
})
export class RatingActivityComponent implements OnInit {
  isOpen = false;
  historyItems: { date: string; time: string; id: number; updatedBy: string }[] = [];
  isLoading: boolean = false;
  isFetchingDetails: boolean = false;
  selectedLog: object = null;
  @Input() vehicleId: string = '';
  @Input() parentPartId: string = '';
  @Output() logDetails = new EventEmitter<object>();

  constructor(private httpClient: HttpClient, private elementRef: ElementRef) {}

  ngOnInit(): void {}

  toggleDropdown(event: MouseEvent) {
    event.stopPropagation();

    this.isOpen = !this.isOpen;

    if (this.isOpen && this.vehicleId && this.parentPartId) {
      this.fetchHistory();
    }

    if (!this.isOpen) {
      this.selectedLog = null;
    }
  }

  fetchHistory() {
    this.isLoading = true;
    const url = environment.api + '/vehicle-parts-history';
    const params = new HttpParams()
      .set('vehicle_id', this.vehicleId)
      .set('parent_part_id', this.parentPartId);

    this.httpClient.get<ApiResponse>(url, { params }).subscribe({
      next: (res) => {
        this.historyItems = res?.['data']?.map((item) => {
          const dateObj = new Date(item?.['created_at']);
          return {
            date: new Intl.DateTimeFormat('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: '2-digit'
            }).format(dateObj),
            time: new Intl.DateTimeFormat('en-US', {
              hour: 'numeric',
              minute: '2-digit',
              hour12: true
            }).format(dateObj),
            id: item.id,
            updatedBy: item.updated_by
          };
        });

        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  getHistoryDetails(log: object) {
    if (!log?.['id'] || this.selectedLog?.['id'] === log['id']) {
      return;
    }

    this.selectedLog = log;
    this.isFetchingDetails = true;

    const url = `${environment.api}/vehicle-parts-history/${log['id']}`;

    this.httpClient.get(url).subscribe({
      next: (res) => {
        this.logDetails.emit(res?.['data']);
        this.isFetchingDetails = false;
        this.isOpen = false;
      },
      error: () => {
        this.isFetchingDetails = false;
        this.selectedLog = null;
      }
    });
  }

  truncateString(name: string, maxLength: number = 16): string {
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...';
    }

    return name;
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.selectedLog = null;
    }
  }
}
